const UserTypeActionTypes = {
  /*****************  GET USERTYPE LIST START  *******************/
  GET_USERTYPE_LIST_START: "get_usertype_list_start",
  GET_USERTYPE_LIST_SUCCESS: "get_usertype_list_success",
  GET_USERTYPE_LIST_FAILURE: "get_usertype_list_failure",
  GET_USERTYPE_LIST_RESPONSE_RESET: "get_usertype_list_response_reset",
  GET_USERTYPE_LIST_RESPONSE_CHANGED: "get_usertype_list_response_changed",
  /*****************  GET USERTYPE LIST END  *******************/

  /*****************  ADD USERTYPE DETAILS START  *******************/
  ADD_USERTYPE_DETAILS_START: "add_usertype_details_start",
  ADD_USERTYPE_DETAILS_SUCCESS: "add_usertype_details_success",
  ADD_USERTYPE_DETAILS_FAILURE: "add_usertype_details_failure",
  ADD_USERTYPE_DETAILS_RESPONSE_RESET: "add_usertype_details_response_reset",
  ADD_USERTYPE_DETAILS_RESPONSE_CHANGED:
    "add_usertype_details_response_changed",
  /*****************  ADD USERTYPE DETAILS END  *******************/

  /*****************  UPDATE USERTYPE DETAILS START  *******************/
  UPDATE_USERTYPE_DETAILS_START: "update_usertype_details_start",
  UPDATE_USERTYPE_DETAILS_SUCCESS: "update_usertype_details_success",
  UPDATE_USERTYPE_DETAILS_FAILURE: "update_usertype_details_failure",
  UPDATE_USERTYPE_DETAILS_RESPONSE_RESET:
    "update_usertype_details_response_reset",
  UPDATE_USERTYPE_DETAILS_RESPONSE_CHANGED:
    "update_usertype_details_response_changed",
  /*****************  UPDATE USERTYPE DETAILS END  *******************/

  /*****************  DELETE USERTYPE DETAILS START  *******************/
  DELETE_USERTYPE_DETAILS_START: "delete_usertype_details_start",
  DELETE_USERTYPE_DETAILS_SUCCESS: "delete_usertype_details_success",
  DELETE_USERTYPE_DETAILS_FAILURE: "delete_usertype_details_failure",
  DELETE_USERTYPE_DETAILS_RESPONSE_RESET:
    "delete_usertype_details_response_reset",
  DELETE_USERTYPE_DETAILS_RESPONSE_CHANGED:
    "delete_usertype_details_response_changed",
  /*****************  DELETE USERTYPE DETAILS END  *******************/

  /*****************  FETCH USERTYPE DETAILS START  *******************/
  FETCH_USERTYPE_DETAILS_START: "fetch_usertype_details_start",
  FETCH_USERTYPE_DETAILS_SUCCESS: "fetch_usertype_details_success",
  FETCH_USERTYPE_DETAILS_FAILURE: "fetch_usertype_details_failure",
  FETCH_USERTYPE_DETAILS_RESPONSE_RESET:
    "fetch_usertype_details_response_reset",
  FETCH_USERTYPE_DETAILS_RESPONSE_CHANGED:
    "fetch_usertype_details_response_changed",
  /*****************  FETCH USERTYPE DETAILS END  *******************/
};
export default UserTypeActionTypes;
